/**
 * Config — 1mind deployment constants (Thryv workspace).
 *
 * Ids come from the "Integration Phased Approach Overview" tab of the
 * Thryv + 1mind Integrations Worksheet. The connect bar keeps its own copy
 * of the embedded ids in src2/ThryvConnectBar/Config.js — that bundle is
 * self-contained on purpose; if these ever diverge, this file is the one
 * page-level code reads.
 */

var Config = new Object();

Config.launcherBase = 'https://launcher.1mind.com/';

/**
 * 1mind's own contract — the launcher mounts into an element with this id
 * and nothing else. Do not rename.
 */
Config.mountId = 'onemind-widget';

/**
 * env: flip to 'production' once 1mind confirms the production deployments
 * carry Thryv's persona. Sandbox still serves their placeholder content
 * ("Ask AI Name Goes Here"). Overridable per call.
 */
Config.env = 'sandbox';

Config.deployments = {

  // Mounts inline into an element you provide.
  embedded: {
    sandbox: 'deployment-fxmqjh5hsl',
    production: 'deployment-95gk4pzs5j',
  },

  // Mounts its own fixed bottom-right overlay. Not used by page-level code
  // — the connect bar already owns that corner.
  widget: {
    sandbox: 'deployment-6gsszb2hdw',
    production: 'deployment-8td62jc9r9',
  },

  // Post-form-submit conversation, seeded with the values the visitor just
  // typed rather than the HubSpot cookie.
  behindTheForm: {
    sandbox: 'deployment-9p7jfwsb6s',
    production: 'deployment-96sdz7hmmr',
  },

};

/**
 * Form field name → 1mind launcher attribute, used by openOnSubmit to turn
 * a submitted form into conversation context. Field names are matched
 * against input name and id.
 *
 * These attribute names follow the guide's `data-*` examples. 1mind's
 * implementation team defines the real ones for Thryv — when they do, this
 * map is the only thing that changes.
 */
Config.formFieldMap = {
  firstname: 'data-firstname',
  lastname: 'data-lastname',
  email: 'data-email',
  company: 'data-company',
  phone: 'data-phone',
  jobtitle: 'data-jobtitle',
  industry: 'data-industry',
  country: 'data-country',
};

export default Config;
